import { render, staticRenderFns } from "./HeaderNavigationLink.vue?vue&type=template&id=18fae974&"
import script from "./HeaderNavigationLink.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports